module.exports = __webpack_public_path__ + "static/media/stock2.711dd62c.png";